import * as Sentry from "@sentry/react"
import type { ReactNode } from "react"
import { ErrorBoundary } from "react-error-boundary"

/**
 * For chat UI mounted on every page: a render error hides that piece instead
 * of unmounting the page around it. It is reported as fatal and tagged
 * `error_boundary`, so an alert can fire when part of chat is down.
 */
export function ChatErrorBoundary({
  name,
  children,
}: {
  name: string
  children: ReactNode
}) {
  return (
    <ErrorBoundary
      fallback={<></>}
      onError={(error) =>
        Sentry.captureException(error, {
          level: "fatal",
          tags: { feature: "chat", error_boundary: name },
        })
      }
    >
      {children}
    </ErrorBoundary>
  )
}
